import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { motion } from 'framer-motion';

const MotionButton = motion(Button);

const AISection = () => {
  return (
    <Box
      className="animated-gradient-bg"
      sx={{
        width: '100%',
        py: { xs: 4, md: 6 },
        color: '#112D4E',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.9, ease: 'easeOut' }}
        style={{ width: '100%' }}
      >
        <Typography
          variant="h2"
          sx={{
            fontWeight: 900,
            fontSize: { xs: '2rem', md: '2.5rem' },
            mb: 2,
            letterSpacing: 1.2,
            textShadow: '0 2px 12px rgba(17,45,78,0.10)',
            background: 'none',
            color: '#3F72AF',
          }}
        >
          Empowering the Future with <Box component="span" sx={{ color: '#3F72AF', fontWeight: 900 }}>AI</Box>
        </Typography>
        <Container maxWidth="md">
          <Typography
            variant="h6"
            sx={{
              color: '#112D4E',
              fontWeight: 400,
              mb: 2,
              textShadow: '0 1px 6px rgba(17,45,78,0.08)',
            }}
          >
            At Virves, we believe Artificial Intelligence is the catalyst for tomorrow's breakthroughs. Our team is passionate about advancing AI to create smart, adaptive solutions that help businesses thrive in a digital-first world.
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: '#112D4E',
              fontWeight: 400,
              mb: 3,
              textShadow: '0 1px 4px rgba(17,45,78,0.07)',
            }}
          >
            Ready to harness the power of AI for your business? Connect with us for a free consultation and discover how our expertise can elevate your operations.
          </Typography>
          <MotionButton
            variant="contained"
            size="large"
            sx={{
              background: 'linear-gradient(90deg, #3F72AF 0%, #112D4E 100%)',
              color: '#F9F7F7',
              fontWeight: 700,
              fontSize: 18,
              px: 4,
              py: 1.2,
              borderRadius: 3,
              boxShadow: '0 4px 16px rgba(63,114,175,0.10)',
              mt: 1,
              textTransform: 'none',
              '&:hover': {
                background: 'linear-gradient(90deg, #112D4E 0%, #3F72AF 100%)',
                color: '#DBE2EF',
              },
            }}
            whileHover={{ scale: 1.06 }}
            whileTap={{ scale: 0.97 }}
          >
            Free AI Consultation
          </MotionButton>
        </Container>
      </motion.div>
    </Box>
  );
};

export default AISection; 